import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { academyApi } from "@/lib/academy";

export function AcademyGlossary() {
  const [data, setData] = useState({ terms: [] });
  const [q, setQ] = useState("");
  useEffect(() => { academyApi.glossary().then(setData).catch(() => {}); }, []);
  const terms = data.terms.filter((t) => (t.term + t.definition).toLowerCase().includes(q.toLowerCase()));
  return (
    <>
      <Seo title="Glossary | Solar Black Belt Academy" description="144 plain-language solar, storage and electrical terms from the Solar Black Belt Academy." />
      <section className="page-hero"><div className="wrap"><span className="eyebrow">ACADEMY GLOSSARY</span><h1>Speak solar fluently.</h1></div></section>
      <section className="wrap academy-section">
        <input className="field" data-testid="academy-glossary-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search a term…" style={{ maxWidth: 380, width: "100%" }} />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))", gap: 14, marginTop: 24 }}>
          {terms.map((t) => <div key={t.id} className="academy-belt-card"><h3 style={{ margin: 0 }}>{t.term}</h3><p className="micro">{t.definition}</p></div>)}
        </div>
      </section>
    </>
  );
}

export function AcademyResources() {
  const [data, setData] = useState({ sources: [], note: "" });
  useEffect(() => { academyApi.resources().then(setData).catch(() => {}); }, []);
  return (
    <>
      <Seo title="Official sources | Solar Black Belt Academy" description="Official manufacturer and government references used by the Solar Black Belt Academy — Tesla documentation and tax sources." />
      <section className="page-hero"><div className="wrap"><span className="eyebrow">OFFICIAL SOURCES</span><h1>Read the originals.</h1></div></section>
      <section className="wrap academy-section">
        <p className="lead" style={{ maxWidth: 760 }}>{data.note}</p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(300px,1fr))", gap: 14, marginTop: 24 }} data-testid="academy-resources-list">
          {data.sources.map((s) => (
            <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" className="academy-belt-card" data-testid={`academy-source-${s.id}`}>
              <h3 style={{ margin: 0 }}>{new URL(s.url).hostname.replace("www.", "")} ↗</h3>
              <p className="micro">{s.scope || ""}{s.reviewed_on ? ` — source check ${s.reviewed_on}` : ""}</p>
            </a>
          ))}
        </div>
        <p className="micro" style={{ marginTop: 20 }}>Dated reference copies are used internally for instructor review only and are not redistributed. Active manufacturer instructions control.</p>
        <Link className="textbutton" to="/academy">← Back to the academy</Link>
      </section>
    </>
  );
}
